<template>
  <div class="product-custom-config">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="search-content">
        <div class="search-left">
          <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="自定义检索:" style="margin-right: 6px;">
              <el-select v-model="searchForm.type" placeholder="选择检索类型" style="width: 130px; height: 26px;">
                <el-option label="按保险条款名称" value="1" />
              </el-select>
            </el-form-item>
            <el-form-item v-show="searchForm.type === '1'" style="margin-right: 0;">
              <el-input
                v-model="searchForm.name"
                placeholder="保险条款名称"
                style="width: 200px; height: 26px;"
                maxlength="100"
                clearable
              />
            </el-form-item>
            <el-form-item style="margin-right: 0; margin-left: 0;">
              <el-button type="primary" @click="handleSearch" style="margin-left: 15px;">搜索</el-button>
              <el-button @click="handleReset">全部</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="search-right">
          <el-button type="success" @click="handleAdd">
            <i class="el-icon-plus"></i> 自定义配置
          </el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" />
      <el-table-column prop="product_name" label="产品名称" align="center" />
      <el-table-column prop="insurance_company_name" label="保险公司" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.rows"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
      />
    </div>

    <!-- 自定义配置弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <custom-config-form
        v-if="dialogVisible"
        :form-data="currentRow"
        :is-view="isView"
        @save="handleSave"
        @cancel="handleCancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getProductConfigList } from '@/api/product'
import CustomConfigForm from './components/CustomConfigForm.vue'

export default {
  name: 'ProductCustomConfig',
  components: {
    CustomConfigForm
  },
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        type: '1',
        name: ''
      },
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      currentRow: null,
      isView: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          rows: this.pagination.rows
        }
        
        // 添加搜索条件
        if (this.searchForm.type === '1' && this.searchForm.name) {
          params.name = this.searchForm.name
        }
        
        const response = await getProductConfigList(params)
        if (response && response.err_code === 0) {
          this.tableData = response.rows || []
          this.pagination.total = response.total || 0
        } else {
          this.$message.error(response?.err_msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取产品配置列表失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        type: '1',
        name: ''
      }
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 新增配置
    handleAdd() {
      this.dialogTitle = '产品配置'
      this.currentRow = null
      this.isView = false
      this.dialogVisible = true
    },
    
    // 查看配置
    handleView(row) {
      this.dialogTitle = '查看产品配置'
      this.currentRow = { ...row }
      this.isView = true
      this.dialogVisible = true
    },
    
    // 编辑配置
    handleEdit(row) {
      this.dialogTitle = '编辑产品配置'
      this.currentRow = { ...row }
      this.isView = false
      this.dialogVisible = true
    },
    
    // 处理保存
    handleSave() {
      this.dialogVisible = false
      this.fetchData()
      this.$message.success('保存成功')
    },
    
    // 处理取消
    handleCancel() {
      this.dialogVisible = false
    },
    
    // 处理弹窗关闭
    handleDialogClose() {
      this.currentRow = null
      this.isView = false
    },
    
    // 每页大小改变
    handleSizeChange(rows) {
      this.pagination.rows = rows
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.product-custom-config {
  padding: 20px;
}

.search-bar {
  background: #f5f5f5;
  padding: 8px 0;
  margin-bottom: 20px;
  border-radius: 4px;
}

.search-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.search-left {
  flex: 1;
}

.search-right {
  flex-shrink: 0;
}

.search-form {
  margin: 0;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 6px;
}

.search-form .el-form-item__label {
  line-height: 27px;
  margin: 0 6px 0 10px;
}

.pagination-wrapper {
  text-align: center;
  margin-top: 20px;
}
</style>